import httpResource from "@/components/infrastructures/functions/http/httpResource";

export default class EstheService {

    public static async checkAvailableLoop() {
        return httpResource.get('/v2/esthe/available-loop-func')
            // .catch((error: any) => {
            //     if (error.response && error.response.data && error.response.data.message && error.response.data.errorCode === 'E2001' ) {
            //         alert('支払が確認できませんでした。こちらからお支払方法の更新を行ってください。: ' + error.response.data.message)
            //     } else {
            //         alert('エラーが発生しました。')
            //     }
            //     window.location.href = '/';
            // });
    }

    public static async checkAvailableTimer() {
        return httpResource.get('/v2/esthe/available-timer-func')
            // .catch((error: any) => {
            //     if (error.response && error.response.data && error.response.data.message && error.response.data.errorCode === 'E2001' ) {
            //         alert('支払が確認できませんでした。こちらからお支払方法の更新を行ってください。: ' + error.response.data.message)
            //     } else {
            //         alert('エラーが発生しました。')
            //     }
            //     window.location.href = '/';
            // });
    }

    public static async checkAvailableWithSoundEsthe() {
        return httpResource.get('/v2/esthe/available-with-soundesthe-func')
            // .catch((error: any) => {
            //     if (error.response && error.response.data && error.response.data.message && error.response.data.errorCode === 'E2001' ) {
            //         alert('支払が確認できませんでした。こちらからお支払方法の更新を行ってください。: ' + error.response.data.message)
            //     } else {
            //         alert('エラーが発生しました。')
            //     }
            //     window.location.href = '/';
            // });
    }

    public static async checkAvailableDrAiAndHealthCare() {
        return httpResource.get('/v2/esthe/available-dr-ai-and-healthcare-func')
            // .catch((error: any) => {
            //     if (error.response && error.response.data && error.response.data.message && error.response.data.errorCode === 'E2001' ) {
            //         alert('支払が確認できませんでした。こちらからお支払方法の更新を行ってください。: ' + error.response.data.message)
            //     } else {
            //         alert('エラーが発生しました。')
            //     }
            //     window.location.href = '/';
            // });
    }

    public static async checkAvailableSoundTherapy() {
        return httpResource.get('/v2/esthe/available-sound-therapy-func')
            // .catch((error: any) => {
            //     if (error.response && error.response.data && error.response.data.message && error.response.data.errorCode === 'E2001' ) {
            //         alert('支払が確認できませんでした。こちらからお支払方法の更新を行ってください。: ' + error.response.data.message)
            //     } else {
            //         alert('エラーが発生しました。')
            //     }
            //     window.location.href = '/';
            // });
    }

    public static async checkAvailableAIEsthe() {
        return httpResource.get('/v2/esthe/available-aiesthe')
            // .catch((error: any) => {
            //     if (error.response && error.response.data && error.response.data.message && error.response.data.errorCode === 'E2001' ) {
            //         alert('支払が確認できませんでした。こちらからお支払方法の更新を行ってください。: ' + error.response.data.message)
            //     } else {
            //         alert('エラーが発生しました。')
            //     }
            //     window.location.href = '/';
            // });
    }
}